import { useState, useEffect } from 'react';
import { useStore } from 'store/StoreContext';
import { callCheckLoggedInApi } from 'requests/RequestLogin';
import { saveGenerator } from 'store/login-user/LoginUserData';
import { HttpStatus } from 'consts/HttpStatus';

export const useCheckLogin = () => {
	const [store, dispatch] = useStore();
	// ログイン状態をstoreから取得して確認
	const [isAuthenticated, setIsAuthenticated] = useState(!!store.loginUserData.gidpk);
	const [loading, setLoading] = useState(!isAuthenticated);
	// storeに情報が無い場合は、cookieにあるsessionIDを使ってログインチェックを行う
	useEffect(() => {
		if (!isAuthenticated) {
			const execute = async () => {
				const result = await callCheckLoggedInApi();
				if (result.status !== HttpStatus.OK || !result.data.isLoggedIn) {
					setLoading(false);
					return;
				}
				// ログインチェックOKならstoreに値を格納してisAuthenticatedをtrueにする
				await saveGenerator(dispatch, result.data.loginUser);
				setIsAuthenticated(true);
				setLoading(false);
			};
			execute();
		}
	}, [isAuthenticated]);
	return {
		loading,
		isAuthenticated,
	};
};
